import React from 'react';
import { Twitter, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Product: [
      { label: 'Features', href: '#features' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Pricing', href: '#pricing' },
    ],
    Company: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
    Legal: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms-of-service' },
      { label: 'Cookie Policy', href: '/cookie-policy' },
      { label: 'GDPR', href: '/gdpr' }
    ]
  };

  return (
    <footer
      className="relative py-16 px-6 lg:px-12"
      style={{ background: '#050508', borderTop: '1px solid rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Main footer content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-5">
              <img
                src="/logo.png"
                alt="TickBoom Logo"
                className="h-8 w-auto"
              />
              <span className="text-lg font-bold tracking-tight">
                Tick<span className="gradient-text">Boom</span>
              </span>
            </div>
            <p className="text-sm text-[#6b7280] mb-6 max-w-xs leading-relaxed">
              The commitment timer that holds you accountable to yourself. Set a timer. Make a promise. Face the result.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://x.com/TickBoomApp"
                aria-label="Twitter / X"
                className="w-9 h-9 rounded-lg flex items-center justify-center text-[#6b7280] hover:text-white transition-colors"
                style={{ border: '1px solid rgba(255,255,255,0.08)' }}
              >
                <Twitter size={16} />
              </a>
              <a
                href="mailto:support@tickboom.app"
                aria-label="Email support"
                className="w-9 h-9 rounded-lg flex items-center justify-center text-[#6b7280] hover:text-white transition-colors"
                style={{ border: '1px solid rgba(255,255,255,0.08)' }}
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-xs font-mono font-semibold uppercase tracking-widest text-[rgba(255,255,255,0.25)] mb-4">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-sm text-[#6b7280] hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <p className="text-xs text-[#6b7280]">
            © {currentYear} TickBoom. All rights reserved.
          </p>
          <p className="text-xs text-[#6b7280]">
            Built with <span className="text-white">discipline</span> and <span className="gradient-text">code</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
